import React from "react";
import { NAVBAR_HEIGHT } from "utilities/constants";
import { useSelector } from "react-redux";
import { selectSnackpassId } from "store/profileSlice";

const OnlineOrdering = () => {
    const storeId = useSelector(selectSnackpassId);

    return (
        <div
            style={{
                height: `calc(100vh - ${NAVBAR_HEIGHT}px)`,
            }}
        >
            <iframe
                src={`https://order.snackpass.co/${storeId}?fromCustomApp=true`}
                title="Online Ordering"
                width="100%"
                height="100%"
            />
        </div>
    );
};

export default OnlineOrdering;
